Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = void 0;
var formatDate = exports.formatDate = function formatDate(dateString) {
  var date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
};